'use client';

import { NetDebtResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  result: NetDebtResult;
  translations: ToolsTranslations['netDebt'];
}

export default function ResultsDisplay({ result, translations }: Props) {
  const amount = result.netDebt ?? 0;
  const formatted = `${Math.abs(amount).toLocaleString('sv-SE')} ${translations.currencySuffix}`;
  const label = amount >= 0 ? translations.resultNetDebtLabel : translations.resultNetCashLabel;

  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-4 border border-gray-200">
        <div className="text-xl font-semibold text-blue-900 mb-1">{label}</div>
        <div className="text-2xl font-semibold text-blue-900">{result.netDebt !== null ? formatted : '—'}</div>
      </div>
      {!result.isValid && result.message && (
        <p className="text-sm text-red-600">{result.message}</p>
      )}
    </div>
  );
}


